//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import libUmum from '../../library/umum'




export default {
  data() {
    return {
      

      form : {
        bulan : '',
        createBy : '',
        createdAt : '',
        id : '',
        layanan : '',
        masterjk : '',
        masterjk_uraian : '',
        masterpekerjaan : '',
        masterpekerjaan_keterangan : '',
        masterpekerjaan_uraian : '',
        masterpendidikan : '',
        masterpendidikan_uraian : '',
        status : '',
        keterangan : '',
        profil_id : '',
        tahun : '',
      },

      opsi : {
        id : '',
        masterkuesioner : 0,
        uraian : '',
        bobot : 0,

      },
     
      list_data : [],
      list_Quesioner : [],
      list_opsi : [],


      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,

      mdl_list_opsi :false,
      mdl_add_opsi : false,
      mdl_edit_opsi : false,

      btn_add: false,

      LIB :libUmum,

      tahun :'',
      semester : '',
      status : 0,

      profil_id : '',

    }
  },
  methods: {
    


    getView : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_LPSE_validasi + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              tahun : this.tahun, 
              semester : this.semester,
              status : this.status,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.cek_load_data = false;
              console.log(res_data);
      });
    },



    editData : function(){
      fetch(this.$store.state.url.URL_LPSE_validasi + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    backwardData : function(){
      fetch(this.$store.state.url.URL_LPSE_validasi + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    getQuesioner : function(){
      // this.$store.commit("shoWLoading");
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_LPSE_validasi, {
          method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              tahun : this.tahun, 
              semester : this.semester,
              profil_id : this.form.profil_id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_Quesioner = res_data.data;
                console.log(res_data.data)
                this.cek_load_data = false;
        });
    },


    selectData(data){
      console.log(data)
      this.form = data;
      this.profil_id = data.profil_id
      this.getQuesioner();
    },

    QuesionerChoose(masteropsiChoose, masteropsi_id){
      if (masteropsiChoose == masteropsi_id) {
        return 'chooseOpsi'
      }
    },


    checkStatus(data){
      if (data == '1') {
        return true
      } else {
        return false        
      }
    },





    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indicatorColor : function(data){
          if (data == 0) {
            return {
              bg : `bg-orange-2`,
              status : false
            }  
          }
          else if(data == 1){
            return {
              bg : `bg-blue-1`,
              status : false
            }
          }
          else if (data == 2){
            return {
              bg : `bg-red-2`,
              status : true
            }
          }

        }


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    var date = new Date();
    this.tahun = date.getUTCFullYear();
    var bulan = date.getMonth();
    this.semester = libUmum.semesterNumber(bulan+1)



    this.getView();
    // this.$store.commit("listJeniskategorilokasi");
    // this.$store.commit("getStorage");

  },
}
